module.exports = __webpack_public_path__ + "static/media/dasa.01e13f88.svg";